// extracted by mini-css-extract-plugin
module.exports = {"uploadwrap":"upload_uploadwrap__9Ps-M","item":"upload_item__37B1a","overlay":"upload_overlay__3OA11","img":"upload_img__2Qqfn","delBtn":"upload_delBtn__mgZgS"};